<script setup>
import CoachApplication from '../elements/CoachApplication.vue';

// Create a mock element object to pass to CoachApplication component
// This mimics how other sections pass data to CoachApplication
const coachApplicationElement = {
  module_section_element_name: 'COACH_BEGIN_APPLICATION_BUTTON',
  element_text: 'BEGIN APPLICATION',
  element_type: 'COACH_BEGIN_APPLICATION' // Changed from 'CoachApplication' to avoid the hardcoded "Apply Now"
};

// Debug: Log the element to make sure it's correct
console.log('CoachKickstart element:', coachApplicationElement);
</script>

<template>
    <section class="kickstart-section">
        <div class="container">
            <h2 class="section-title">KICKSTART YOUR <span class="red-text">C.O.A.C.H CAREER</span></h2>
            <p class="section-description">
                Fill out the application form now to join the next available training!
            </p>
            <CoachApplication :element="coachApplicationElement" />
        </div>
    </section>
</template>

<style lang="scss" scoped>
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.red-text {
    color: #EF3147 ;
}

.kickstart-section {
    background-color: #1a1b3e;
    color: white;
    padding: 2rem 0 3rem 0;
    text-align: center;
    margin: 0;

    @media (max-width: 768px) {
        margin: 0;
        padding: 2rem 0;
    }

    .section-title {
        font-size: 2.25rem;
        font-weight: bold;
        margin-bottom: 1rem;
        line-height: 1.2;
        
        .red-text {
            color: #EF3147 ;
        }
    }

    .section-description {
        font-size: 1rem;
        margin-bottom: 2rem;
        line-height: 1.5;
    }

    // Override CoachApplication button styles to match the original CTA design
    :deep(.btn-danger) {
        background-color: #EF3147  !important;
        color: black !important;
        border: none !important;
        padding: 1rem 2rem !important;
        font-size: 1.2rem !important;
        font-weight: bold !important;
        border-radius: 8px !important;
        cursor: pointer !important;
        transition: background-color 0.3s ease !important;
        float: none !important;
        display: inline-block !important;
        text-decoration: none !important;
        text-transform: uppercase !important;

        &:hover {
            background-color:#EF3147 !important;
            border-color: #EF3147  !important;
            color: white !important;
        }
        
        &:focus {
            background-color: #EF3147  !important;
            border-color: #EF3147  !important;
            color: white !important;
            box-shadow: 0 0 0 0.2rem rgba(229, 62, 62, 0.25) !important;
        }

        &:active {
            background-color: #EF3147  !important;
            border-color: #EF3147  !important;
            color: white !important;
        }

        &:visited {
            color: white !important;
        }
    }
}
</style>